

/** Sends a VirtualPageView event to Google Analaytics when custom URL DOM is present */
export class CustomUrlTracker {
  constructor() {
    this.dataLayer = window.dataLayer = window.dataLayer || [];

    $('[data-ua-custom-url]').each((index, element) => {
      this.pageView({
        url: $(element).data('ua-custom-url'),
        title: $(element).data('ua-custom-title') || document.title
      });
    });
  }

  /**
   * Sends the page view event to Google Analytics
   * @param {object} options Page URL and title of custom URL
   */
  pageView(options) {
    this.dataLayer.push({
      event: 'VirtualPageView',
      virtualPageURL: `${document.location.pathname}/${options.url}`,
      virtualPageTitle: options.title
    });
  }

  /**
   * Sends a page view event for PDF clicks
   * @param {object} options
   */
  fileView(options) {
    this.dataLayer.push({
      event: 'VirtualPageView',
      virtualPageURL: `${document.location.pathname}/${options.filename}`,
      virtualPageTitle: `${options.filetype}: ${options.filename}`
    });
  }
}
